import { poTemplateSchema } from "@redotech/redo-fulfillment-operations-common/purchase-order-document";
import * as z from "zod";

export const getPoTemplates = {
  name: "getPoTemplates" as const,
  input: z.object({}),
  output: z.array(poTemplateSchema),
};
